import React, { useEffect } from 'react';
import './UserAccount.scss';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Logout from '@mui/icons-material/Logout';
import { useHistory } from 'react-router-dom';
import { useUser, useUserTokens } from '../../../store/actions';
import { useStoreContext } from '../../../store/context';
import { ROUTE_PATHS } from 'src/routes';
import { removeUser } from 'src/shared/Login/RefreshAuth';
interface UserAccountProps {
  firstName: string;
  lastName: string;
  email: string;
  appRoles: string;
}

const UserAccount: React.FC<UserAccountProps> = ({ firstName, lastName, email, appRoles }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [, dispatch] = useStoreContext();

  const history = useHistory();
  const setUser = useUser(dispatch);
  const setUserTokens = useUserTokens(dispatch);

  const handleLogOut = () => {
    removeUser(setUser, setUserTokens);
    setAnchorEl(null);

    if (window.location.pathname.includes('/inap')) {
      history.push({ pathname: `/ui`, key: 'from-inap' })
      window.location.reload();
    }
    else if (window.location.pathname.includes(`${ROUTE_PATHS.data_import}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.contacts}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.sample}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.group}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.area}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.field_sample_sites}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.field_samples}`)
    ) {
      history.push(`${ROUTE_PATHS.home}`)
      window.location.reload();
    }
    else {
      window.location.reload();
    }
  };


  useEffect(() => {
    if (!localStorage.getItem('user') || localStorage.getItem('user') === undefined) {
      localStorage.removeItem('authExpires')
    }
  }, []);


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div
      id="acct"
    >
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', marginRight: '.75rem'}}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ width: 32, height: 32, fontSize: '1em' }}>{firstName.charAt(0) + lastName.charAt(0)}</Avatar>
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        onMouseLeave={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <div
        >
          <div className="user-menu-section $skyblue">
            <div className="acct-user-initials">{firstName && lastName ? firstName?.charAt(0) + lastName?.charAt(0) : ''}</div>{" "}

            <span className="user-names">{firstName && lastName ? firstName + " " + lastName + ", " : ''} {appRoles ? appRoles?.toString() : ''}<br /></span>
            <span className="email">{email ? email : ''}</span>
          </div>
          <MenuItem onClick={handleLogOut}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </div>

      </Menu>      
    </div>
  );
}

export default UserAccount;
